export default function findCorrelationId(content: string): string | null {
    // Replaced /(([A-Za-z0-9])+-)+([A-Za-z0-9])+/g; because of Sonar report
    const regexp = /[A-Za-z0-9]{4}(?:-[A-Za-z0-9]{4}){7}/;

    const match = content.match(regexp);
    return match ? match[0] : null;
}
